import { Component, OnInit, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-justificativa',
  templateUrl: './modal-justificativa.component.html',
  styleUrls: ['./modal-justificativa.component.scss']
})
export class ModalJustificativaComponent implements OnInit {

  @Input() cabecalho: string;
  justificativa = new FormControl('', [Validators.required]);

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
}
